import { useMemo } from 'react';

import { PRODUCT_NAVIGATION_LINKS } from '~/consts/productsNavigation';

import { UserType } from '~/types/responses/users';

import { filterNavigationLinksForUser } from '~/utils/navigationLinks';

export default function useProductNavigationLinks(user: App.User | UserType | null | undefined) {
  return useMemo(() => filterNavigationLinksForUser(PRODUCT_NAVIGATION_LINKS, user), [user]);
}
